import React, {useContext, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

import FormControl from '@mui/material/FormControl';
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import {ApplicationsTableContext} from "../../../../context/ApplicationsTableContext";
import FetchHelper from "../../../Utils/helper";
import {OAuthContext} from "../../../../context/OAuthContext";
// import {FilterListType} from "../type";
import RequestResultSnackbar from "../../RequestResultSnackbar/RequestResultSnackbar";
import {checkIfTokenExpired} from "../../utils";

const SearchFilter = () => {
    let navigate = useNavigate();
    const { t } = useTranslation('common');
    const {oauthData} = useContext(OAuthContext);
    const helper = new FetchHelper(oauthData?.token);
    const isTokenExpired = oauthData?.isTokenExpired();

    const {pendingApplicationsList, setFilteredLists, setTitle, setActiveIndex, setErrorApplicationsTable} = useContext(ApplicationsTableContext);

    const [searchValue, setSearchValue] = useState<string>("");
    const [showCloseButton, setShowCloseButton] = useState<boolean>(false);

    const [isTokenExpireSnackbar, setIsTokenExpireSnackbar] = useState<{ open: boolean, message: string}>({ open: false, message: ""})

    const handleChange = ({target: {value: inputValue}}: { target: { value: string } }) => {
        setSearchValue(inputValue);
        if(showCloseButton) setShowCloseButton(false);
        if(inputValue === "") {
            setFilteredLists(pendingApplicationsList)
            setTitle(t("selection"))
            setActiveIndex(1)
        }
    }

// TODO: CREATE AN ALERT COMMAND

    const handleSubmit = () => {
        if(checkIfTokenExpired(oauthData, isTokenExpired)) {
            setIsTokenExpireSnackbar(prevState => ({...prevState, open: true, message: t("token_expired")}));
            return;
        }
        if(searchValue){
            const searchString = searchValue.toLowerCase();

            helper.getApplications(searchString).then(res => {
                // const newList = res.filter((list: FilterListType) => {
                //     return list.salesPartner.name.toLowerCase().includes(searchString) || list.status.toLowerCase().includes(searchString)
                //         || list.editor?.name.toLowerCase().includes(searchString) || list.applicationNumber.toLowerCase().includes(searchString)
                //         || list.type.toLowerCase().includes(searchString)
                //         || (list.baseData.recruitCompany
                //             ? list.baseData.recruitCompany.toLowerCase().includes(searchString)
                //             : list.baseData.recruitContacts[0]?.firstName.toLowerCase().includes(searchString)
                //             || list.baseData.recruitContacts[0]?.lastName.toLowerCase().includes(searchString))
                // })
                setFilteredLists(res);
                setShowCloseButton(true);
                setTitle(`${res.length} ${t("search_result")} "${searchValue}"`)
                setActiveIndex(-1)
                navigate("/");
            }).catch(_ => {
                setFilteredLists([])
                setErrorApplicationsTable(prevState => ({...prevState, error: true, message: t("error_occurred")}))
                setShowCloseButton(true);
                setTitle(`${t("error_occurred")}`)
                setActiveIndex(-1)
                navigate("/");
            })
            return
        }
        window.alert(t("write_something"))
    }

    const handleCloseButton = () => {
        setSearchValue("");
        setShowCloseButton(false);
        setFilteredLists(pendingApplicationsList);
        setTitle(t("selection"))
        setActiveIndex(1)
    }

    return (
        <>
        <FormControl sx={{mb: 3, width: "100%"}} variant="outlined">
            <InputLabel htmlFor="search-application">{t("search_label")}</InputLabel>
            <OutlinedInput
                id="search-application"
                type="text"
                onChange={handleChange}
                value={searchValue}
                endAdornment={
                    <InputAdornment position="end">
                        {showCloseButton ?
                            <IconButton
                                aria-label="remove input value"
                                edge="end"
                                onClick={handleCloseButton}
                            >
                                <CloseIcon/>
                            </IconButton>
                            : <IconButton
                                aria-label="trigger search"
                                edge="end"
                                onClick={handleSubmit}
                            >
                                <SearchIcon/>
                            </IconButton>}
                    </InputAdornment>
                }
                label={t("search_label")}
            />
        </FormControl>
            <RequestResultSnackbar anchorOrigin={{vertical: "top", horizontal: "right"}} open={isTokenExpireSnackbar.open}
                                   onClose={() => setIsTokenExpireSnackbar(prevState => ({...prevState, open: false}))} autoHideDuration={3000} status="error"
                                   message={isTokenExpireSnackbar.message}/>
        </>
    );
};

export default SearchFilter;